import URLS from './urls';
import apiClient from './apiClient';
import { ROUTES } from 'App';
import { StoreModel } from './types';

const s3Url = 'https://gy-soft.s3.ap-northeast-2.amazonaws.com';
const couldFrontUrl = 'https://dumd06kfzac3p.cloudfront.net';

const ESignApi = {
  // 1. 전자계약서 조회 - 매장 정보
  getStoreOfContract: async (businessNumber: string) => {
    const res = await apiClient.get(URLS.getStoreOfContract, {
      params: {
        businessRegistrationCertificateNumber: businessNumber,
      },
    });
    const data: StoreModel[] = res.data.data || [];

    data.forEach((item) => {
      if (item.businessDeclarationCertificateUrl) {
        item.businessDeclarationCertificateUrl = item.businessDeclarationCertificateUrl.replace(
          s3Url,
          couldFrontUrl
        );
      }
      if (item.bankFileUrl) {
        item.bankFileUrl = item.bankFileUrl.replace(s3Url, couldFrontUrl);
      }
      if (item.businessRegistrationCertificateUrl) {
        item.businessRegistrationCertificateUrl = item.businessRegistrationCertificateUrl.replace(
          s3Url,
          couldFrontUrl
        );
      }
    });

    return data;
  },

  // 2. 전자계약서 조회 - 서비스 이용 동의
  postAgreementOfContract: async (agreementData: object) => {
    // agreementData는 객체 형태 { storeId, agreedTerms... }
    const response = await apiClient.post(URLS.postAgreementOfContract, agreementData);
    return response.data;
  },

  // 3. 모두사인 서명 문서 받기
  // 없는 경우, 서명되지 않았음
  getModusignDocument: async (storeId: number, status: string) => {
    const response = await apiClient.get(URLS.getModusignDocument, {
      params: {
        storeId,
        status,
      },
    });
    const data = response.data.data;

    // 응답 예시
    // 데이터 없을 경우 : {"resultCode":200,"resultMessage":"success"}
    // 데이터 없을 경우 : {
    //     "resultCode": 200,
    //     "resultMessage": "success",
    //     "data": {
    //         "id": "1962794484812050433", // documentId
    //         "status": "completed",
    //         "fileName": "꼬르륵 가맹점 계약서 - 빵빵이"
    //         "fileUrl": "꼬르륵 가맹점 계약서 - 빵빵이.png"
    //     }
    // }

    if (data?.fileUrl) {
      data.fileUrl = data.fileUrl.replace(s3Url, couldFrontUrl);
    }

    return response.data.data ?? null;
  },

  // 4. 모두사인 보안 링크 받기
  getModusignLink: async (businessNumber: string, signRedirectUrl: string) => {
    const redirectUrl = `https://kkoruruk.com/#${ROUTES.eSignSign}?businessNumber=${businessNumber}&${signRedirectUrl ? `redirectUrl=${signRedirectUrl}` : ''}`;
    // const redirectUrl = `http://localhost:3000/#${ROUTES.eSignSign}?businessNumber=${businessNumber}&${signRedirectUrl ? `redirectUrl=${signRedirectUrl}` : ''}`;

    const response = await apiClient.post(URLS.getModusignLink, null, {
      params: {
        businessNumber,
        redirectUrl,
      },
    });

    return response.data.data;
  },

  // 5. 전자계약서 제출 (multipart/form-data)
  uploadContract: async ({
    storeId,
    documentId,
    termsAccept,
  }: {
    storeId: number;
    documentId: string;
    termsAccept: Blob;
  }) => {
    const formData = new FormData();

    // 단일 파일
    if (termsAccept) {
      formData.append('termsAccept', termsAccept, 'termsAccept.pdf');
    }

    const response = await apiClient.post(URLS.uploadContract, formData, {
      params: { storeId, documentId },
      paramsSerializer: (params) => {
        // 배열 쿼리 파라미터 직렬화
        return Object.entries(params)
          .map(([key, value]) => {
            if (Array.isArray(value)) {
              return value
                .map((v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`)
                .join('&');
            }
            return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
          })
          .join('&');
      },
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
  },
};

export default ESignApi;
